import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useCity } from "../context/CityContext";
import logo from "./../../logo.png";
import search from "./../../search.svg";
import user from "./../../user.svg";

const Header = () => {
  const { city, setCity } = useCity();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="w-[90%] lg:w-[80%] mx-auto py-3">

      <div className="flex items-center justify-between">

        {/* Logo */}
        <Link to="/">
          <img className="h-8 lg:h-10" src={logo} alt="happenhood" />
        </Link>

        {/* Desktop Search */}
        <div className="hidden md:block relative w-72 lg:w-96">
          <input
            type="text"
            placeholder="Search"
            className="w-full h-9 pl-3 pr-10 bg-gray-100 border border-gray-100 focus:outline-none"
          />
          <img
            src={search}
            alt="search"
            className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 pointer-events-none"
          />
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center gap-6 text-gray-800 font-medium">

          <Link to="/about-us" className="hover:underline">
            About us
          </Link>

          <Link to="/contact-us" className="hover:underline">
            Contact us
          </Link>

          <Link to="/categories" className="hover:underline">
            Categories
          </Link>

          <Link
            to="#"
            onClick={(e) => e.preventDefault()}
            className="px-5 py-[3px] bg-gray-300 text-gray-500 cursor-not-allowed rounded"
          >
            Create Event
          </Link>

        </nav>

        {/* Right Section */}
        <div className="flex items-center gap-4">

          {/* City */}
          <select
            value={city}
            onChange={(e) => {
              setCity(e.target.value);
              window.location.reload();
            }}
            className="text-sm bg-transparent border-none focus:outline-none cursor-pointer hidden sm:block"
          >
            <option value="Noida">Noida</option>
            <option value="Delhi">Delhi</option>
            <option value="Mumbai">Mumbai</option>
            <option value="Kolkata">Kolkata</option>
          </select>

          {/* User */}
          <img src={user} alt="user" className="w-4 h-4" />

          {/* Hamburger (Mobile) */}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="lg:hidden text-2xl"
          >
            ☰
          </button>

        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden mt-4 space-y-4 border-t pt-4">

          {/* Mobile Search */}
          <div className="relative w-full">
            <input
              type="text"
              placeholder="Search"
              className="w-full h-9 pl-3 pr-10 bg-gray-100 border border-gray-100 focus:outline-none"
            />
            <img
              src={search}
              alt="search"
              className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 pointer-events-none"
            />
          </div>

          <Link to="/about" className="block">
            About us
          </Link>

          <Link to="/contact-us" className="block">
            Contact us
          </Link>

          <Link to="/categories" className="block">
            Categories
          </Link>

          <Link
            to="#"
            onClick={(e) => e.preventDefault()}
            className="block bg-gray-300 text-gray-500 cursor-not-allowed px-4 py-2 rounded w-fit"
          >
            Create Event
          </Link>

        </div>
      )}
    </header>
  );
};

export default Header;